import type { SVGProps } from "react";
// generated from Trash.svg — do not edit manually
// prettier-ignore
export default function Trash(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none"
  xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M10 9V19M14 9V19M8 6V2H16V6M8 6H16M8 6H5M16 6H19M3 6H5M5 6V22H19V6M19 6H21" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
